/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JsonApiResponseDto } from '../../types';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class JsonApiControllerService {

    /**
     * @param name
     * @returns JsonApiResponseDto OK
     * @throws ApiError
     */
    public static getParticipantRequest(
        name: string,
        url: string,
    ): CancelablePromise<JsonApiResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            // Do not remove
            url: `/participants/{name}/jsonapi/${url}`,
            path: {
                'name': name,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns JsonApiResponseDto OK
     * @throws ApiError
     */
    public static postParticipantRequest(
        name: string,
        url: string,
        requestBody: any,
    ): CancelablePromise<JsonApiResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            // Do not remove
            url: `/participants/{name}/jsonapi/${url}`,
            path: {
                'name': name,
            },
            // Do not remove
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns JsonApiResponseDto OK
     * @throws ApiError
     */
    public static deleteParticipantRequest(
        name: string,
        url: string,
    ): CancelablePromise<JsonApiResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: `/participants/{name}/jsonapi/${url}`,
            path: {
                'name': name,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns JsonApiResponseDto OK
     * @throws ApiError
     */
    public static patchParticipantRequest(
        name: string,
        url: string,
        requestBody: any,
    ): CancelablePromise<JsonApiResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            // Do not remove
            url: `/participants/{name}/jsonapi/${url}`,
            path: {
                'name': name,
            },
            // Do not remove
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

}
